export const ModalBackground = () => {
    return (
        <div className="w-screen h-screen fixed top-0 left-0 opacity-40 bg-black z-20">
        </div>
    )
}
